import { jsx } from "react/jsx-runtime";
import { useOnClickOutside } from "@flatfile/design-system";
import { useRef, useState, useEffect } from "react";
import { useEditorValueContext } from "../../context/useEditorValueContext.js";
import { EDITOR_ID, getEditedValue } from "../../utils/cells.js";
import { isElementInNewRowWrapper, isElementCloseAddNewRow } from "../../utils/add-rows.js";
import { EditorContainerWrapper } from "./Styles.js";
const EditorContainer = ({
  columnConfig,
  editor: EditorComponent,
  data: tempData,
  cellRef,
  keyPressValue,
  status,
  mutated,
  onChangeEditorState,
  onUpdateCell,
  onCellArrowDown,
  onCellArrowUp,
  isEditing,
  isGhostRow,
  isLastRow,
  isLastColumn,
  isFirstColumn,
  isFirstNonHeaderRow,
  isNewRowCell,
  cell,
  rowData
}) => {
  const containerRef = useRef(null);
  const editorRef = useRef(null);
  const { editorValue, setEditorValue } = useEditorValueContext();
  const [currentValue, setCurrentValue] = useState(tempData == null ? void 0 : tempData.value);
  const [hasChanged, setHasChanged] = useState(false);
  const getNewValue = () => {
    var _a;
    const newValue = ((_a = editorRef == null ? void 0 : editorRef.current) == null ? void 0 : _a.value) || currentValue;
    return getEditedValue(newValue, columnConfig);
  };
  const handleClose = () => {
    var _a;
    setHasChanged(false);
    setEditorValue(null);
    onChangeEditorState({});
    (_a = cellRef == null ? void 0 : cellRef.current) == null ? void 0 : _a.focus();
  };
  const handleCurrentValue = (value) => {
    setHasChanged(true);
    setEditorValue(value);
    setCurrentValue(value);
  };
  const handlePublish = (value, changed, closeRow) => {
    if (!hasChanged && !changed) {
      return handleClose();
    }
    const newValue = value ?? getNewValue();
    if (isGhostRow && newValue) {
      onUpdateCell(newValue, closeRow);
    } else if (!isGhostRow && newValue !== void 0) {
      onUpdateCell(newValue, closeRow);
    }
    handleClose();
  };
  const handleKeydown = (event) => {
    var _a;
    if (event.key === "Escape") {
      handleClose();
      (_a = cellRef == null ? void 0 : cellRef.current) == null ? void 0 : _a.focus();
    }
    if (event.key === "Enter") {
      handlePublish();
      if (!isNewRowCell) {
        if (event.shiftKey) {
          onCellArrowUp(cellRef);
        } else {
          onCellArrowDown(cellRef);
        }
      }
    }
    if (event.key === "Tab") {
      handlePublish();
    }
  };
  useOnClickOutside(containerRef, (event) => {
    var _a;
    const target = event == null ? void 0 : event.target;
    if (isNewRowCell && (event == null ? void 0 : event.target)) {
      const isClickedInsideNewRowWrapper = isElementInNewRowWrapper(target);
      const isCloseButton = isElementCloseAddNewRow(target);
      if (isClickedInsideNewRowWrapper) {
        handlePublish();
      } else {
        handlePublish(void 0, false, !isCloseButton);
      }
    } else {
      handlePublish();
    }
    (_a = cellRef == null ? void 0 : cellRef.current) == null ? void 0 : _a.blur();
  });
  useEffect(() => {
    var _a;
    if (editorRef && isEditing) {
      (_a = editorRef == null ? void 0 : editorRef.current) == null ? void 0 : _a.focus();
    }
  }, [editorRef, isEditing]);
  useEffect(() => {
    if (editorValue)
      handleCurrentValue(editorValue);
  }, []);
  if (!isEditing || !EditorComponent)
    return null;
  return /* @__PURE__ */ jsx(
    EditorContainerWrapper,
    {
      ref: containerRef,
      id: EDITOR_ID,
      onKeyDown: handleKeydown,
      tabIndex: 0,
      isLastRow,
      isLastColumn,
      isFirstNonHeaderRow,
      isFirstColumn,
      children: /* @__PURE__ */ jsx(
        EditorComponent,
        {
          columnConfig,
          onUpdateCell: handlePublish,
          keyPressValue,
          setCurrentValue: handleCurrentValue,
          editorRef,
          mutated,
          isLastRow,
          isFirstNonHeaderRow,
          isFirstColumn,
          isLastColumn,
          isNewRowCell,
          data: {
            value: editorValue || (tempData == null ? void 0 : tempData.diffValue) || (tempData == null ? void 0 : tempData.value),
            status: cell == null ? void 0 : cell.status
          },
          hasChanged,
          rowData,
          ...status
        }
      )
    }
  );
};
export {
  EditorContainer
};
